// SPDX-FileCopyrightText: 2017-2022 City of Espoo
//
// SPDX-License-Identifier: LGPL-2.1-or-later

import React, { useContext, useState } from 'react'

import { isLoading } from 'lib-common/api'
import { useBoolean } from 'lib-common/form/hooks'
import { formatPersonName } from 'lib-common/names'
import { CollapsibleContentArea } from 'lib-components/layout/Container'
import { H2 } from 'lib-components/typography'

import { useTranslation } from '../../state/i18n'
import { useTitle } from '../../utils/useTitle'
import { renderResult } from '../async-rendering'
import PersonDetails from '../person-shared/PersonDetails'

import type { PersonState } from './state'
import { PersonContext } from './state'

export default React.memo(function PersonFridgeHead() {
  const { i18n } = useTranslation()
  const { person, permittedActions } = useContext<PersonState>(PersonContext)
  const [open, setOpen] = useState(true)
  const [sensitiveDetailsOpen, { toggle: toggleSensitiveDetails }] =
    useBoolean(false)

  useTitle(
    person.map(
      (value) =>
        `${formatPersonName(value, 'Last First')} | ${i18n.titles.customers}`
    )
  )

  return (
    <div data-qa="person-info-section" data-isloading={isLoading(person)}>
      <CollapsibleContentArea
        title={<H2>{i18n.personProfile.personDetails}</H2>}
        open={open}
        toggleOpen={() => setOpen(!open)}
        $opaque
        $paddingVertical="L"
        data-qa="person-info-collapsible"
      >
        {renderResult(person, (person) => (
          <PersonDetails
            person={person}
            isChild={false}
            permittedActions={permittedActions}
            sensitiveDetailsOpen={sensitiveDetailsOpen}
            onToggleSensitiveDetails={toggleSensitiveDetails}
          />
        ))}
      </CollapsibleContentArea>
    </div>
  )
})
